function countPendingEofficeActions({
  supplyResult,
  purchaseResult,
  ticketMasters,
  tickets,
} = {}) {
  const employeeId = ticketMasters?.current_employee?.employee_id;
  const canManage = ticketMasters?.can_manage === true;

  return {
    supplyProposals: Number(supplyResult?.data?.data?.pending_for_me) || 0,
    purchaseRequests: Number(purchaseResult?.data?.data?.pending_approval) || 0,
    tickets: (Array.isArray(tickets) ? tickets : []).filter(
      (ticket) =>
        ticket.status === "PENDING_APPROVAL" &&
        (canManage ||
          (employeeId && ticket.approver_employee_id === employeeId)),
    ).length,
  };
}

function hasPendingEofficeActions(counts = {}) {
  return Object.values(counts).some((count) => Number(count) > 0);
}

module.exports = { countPendingEofficeActions, hasPendingEofficeActions };
